import { HttpFSWalletQrisRepository } from '../../../../data/repository/fs-wallet-qris/http-fs-wallet-qris.repository';
import { FSWalletQrisRepository } from '../../../repository/fs-wallet-qris.repository';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const WalletQrisHttpProvider = [
  { provide: FSWalletQrisRepository, useClass: HttpFSWalletQrisRepository },
];
